"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.broadcastTx = exports.fetchTxs = exports.fetchBlockHeight = exports.fetchEstimatedFees = exports.fetchBalances = void 0;
var logs_1 = require("@ledgerhq/logs");
var network_1 = __importDefault(require("../../../../network"));
var env_1 = require("../../../../env");
var getFilecoinURL = function (path) {
    var baseUrl = (0, env_1.getEnv)("API_FILECOIN_ENDPOINT");
    if (!baseUrl)
        throw new Error("API base URL not available");
    return "".concat(baseUrl).concat(path ? path : "");
};
var fetch = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var url, opts, rawResponse, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFilecoinURL(path);
                opts = {
                    method: "GET",
                    url: url
                };
                return [4 /*yield*/, (0, network_1["default"])(opts)];
            case 1:
                rawResponse = _a.sent();
                data = rawResponse.data;
                (0, logs_1.log)("http", url);
                return [2 /*return*/, data];
        }
    });
}); };
var send = function (path, data) { return __awaiter(void 0, void 0, void 0, function () {
    var url, opts, rawResponse, responseData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFilecoinURL(path);
                opts = {
                    method: "POST",
                    url: url,
                    data: JSON.stringify(data),
                    headers: { "Content-Type": "application/json" }
                };
                return [4 /*yield*/, (0, network_1["default"])(opts)];
            case 1:
                rawResponse = _a.sent();
                responseData = rawResponse.data;
                (0, logs_1.log)("http", url);
                return [2 /*return*/, responseData];
        }
    });
}); };
var fetchBalances = function (addr) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/addresses/".concat(addr, "/balance"))];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data]; // TODO Validate if the response fits this interface
        }
    });
}); };
exports.fetchBalances = fetchBalances;
var fetchEstimatedFees = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, send("/fees/estimate", request)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data]; // TODO Validate if the response fits this interface
        }
    });
}); };
exports.fetchEstimatedFees = fetchEstimatedFees;
var fetchBlockHeight = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/network/status")];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data]; // TODO Validate if the response fits this interface
        }
    });
}); };
exports.fetchBlockHeight = fetchBlockHeight;
var fetchTxs = function (addr) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/addresses/".concat(addr, "/transactions"))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.txs]; // TODO Validate if the response fits this interface
        }
    });
}); };
exports.fetchTxs = fetchTxs;
var broadcastTx = function (message) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, send("/transaction/broadcast", message)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response]; // TODO Validate if the response fits this interface
        }
    });
}); };
exports.broadcastTx = broadcastTx;
//# sourceMappingURL=api.js.map